import * as React from 'react';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { NiButton } from '@component/index';
import { localizedString } from '@locale/index';

export interface AddButtonPropsInfo {
  id?: string;
  icon?: React.ReactNode;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  style?: any;
  loading?: boolean;
  disabled?: boolean;
}

export const AddButton = ({ id, icon, title, onClick, style, loading, disabled }: AddButtonPropsInfo) => {
  return (
    <NiButton
      id={id}
      type="default"
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      style={{
        width: 'auto',
        // border: 0,
        ...style
      }}
      icon={icon || <PlusOutlined />}
    >
      {
        title || localizedString('common_add')
      }
    </NiButton >
  );
};
